export const ENTITY_SANDBOXES_PATH = '/:entityName/sandboxes';
export const ENTITY_SANDBOX_DETAIL_PATH =
  '/:entityName/sandboxes/:sandboxId/:tab(overview|logs)?';
